import script from "./CreateBooking.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateBooking.vue?vue&type=script&setup=true&lang=ts"

import "./CreateBooking.vue?vue&type=style&index=0&id=21437fcc&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21437fcc"]])

export default __exports__